import * as api from '@/api/main/linkImport'

export default {
  namespaced: true,
  state: {
    tasks: []
  },
  mutations: {
    SET_TASKS(state, tasks) {
      if (Array.isArray(tasks)) state.tasks = tasks
      else if (Array.isArray(tasks && tasks.list)) state.tasks = tasks.list
      else state.tasks = tasks && typeof tasks === 'object'
        ? Object.values(tasks).filter(item => item && item.id).sort((a, b) => Number(b.id) - Number(a.id))
        : []
    },
    UPSERT_TASK(state, task) {
      if (!task || !task.id) return
      state.tasks = [task, ...state.tasks.filter(item => item.id !== task.id)]
    }
  },
  actions: {
    getAgreement: () => api.getAgreement(),
    signAgreement: (context, data) => api.signAgreement(data),
    createTask: (context, data) => api.createLinkTask(data),
    getTasks: () => api.getLinkTasks(),
    claimItem: (context, data) => api.claimLinkItem(data),
    reportItem: (context, data) => api.reportLinkItem(data),
    waitForPlugin: (context, data) => api.waitForLinkPlugin(data),
    finishTask: (context, data) => api.finishLinkTask(data),
  }
}
